module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var React = __webpack_require__(2);
	var PropTypes = React.PropTypes;
	var coverflow = __webpack_require__(3);
	var isEquivalent = __webpack_require__(8);

	var Coverflow = React.createClass({
	  displayName: 'Coverflow',

	  activateCoverflow: function activateCoverflow() {
	    if (this.props.children.length != 0 && this.node) {
	      coverflow.initialize(this.node, this.props);
	      coverflow.setActive(parseInt(this.props.active));
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.activateCoverflow();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    coverflow.unmount();
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextPropsReadOnly) {
	    var nextProps = {};
	    _extends(nextProps, nextPropsReadOnly);
	    if (isEquivalent(this.props, nextProps)) return false;else {
	      var temp = parseInt(nextProps.active);
	      nextProps.active = this.props.active;
	      if (isEquivalent(this.props, nextProps)) {
	        if (temp >= 0 && temp < this.props.children.length) coverflow.setActive(temp);
	        return false;
	      } else return true;
	    }
	  },
	  render: function render() {
	    var _this = this;

	    return React.createElement(
	      'div',
	      { style: { width: '100%' }, onLoad: this.activateCoverflow,
	        ref: function ref(node) {
	          _this.node = node;_this.activateCoverflow();
	        } },
	      this.props.children
	    );
	  }
	});

	module.exports = Coverflow;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(5);
	__webpack_require__(6);
	var createStyleSheet = __webpack_require__(7);

	var count, images, dim, offset, center, angle, dist, shift,
	    pressed, reference, amplitude, target, velocity, timeConstant,
	    xform, frame, timestamp, ticker, oldActiveIndex, starttimestamp, tapMaxConstant,
	    onActiveClick, onChange, view, viewHeight;

	function initialize(container, options) {
	  options = options || {};
	  pressed = false;
	  oldActiveIndex = 0;
	  timeConstant = options.timeConstant || 250; // ms
	  tapMaxConstant = options.tapMaxConstant || 150; // ms
	  offset = target = 0;
	  reference = amplitude = velocity = frame = undefined;
	  angle = options.angle || -60;
	  dist = options.angle || -150;
	  shift = options.shift || 10;
	  onActiveClick = options.onActiveClick || function () {};
	  onChange = options.onChange || function () {};
	  container = (typeof container === 'string') ? document.getElementById(container) : container;
	  count = container.children.length;
	  images = [];
	  while (images.length < count) images.push(container.children.item(images.length));
	  var maxHeight = 0, maxWidth = 0;
	  var tagName = options.tagName || images[0].tagName;
	  images.map(function (el, index) {
	    el.onclick = function (e) {
	      flowTo(index);
	      e.preventDefault();
	      e.stopPropagation();
	    };
	    maxHeight = maxHeight > el.scrollHeight ? maxHeight : el.scrollHeight;
	    maxWidth = maxWidth > el.style.width ? maxWidth : el.style.width;
	  });
	  maxHeight = options.maxHeight || maxHeight;
	  maxWidth = options.maxWidth || maxWidth;
	  container.className += ' coverflow';
	  container.style.height = maxHeight * 1.1;
	  createStyleSheet(tagName, maxHeight, maxWidth);
	  images.map(function (el, index) {
	    maxHeight = maxHeight > el.scrollHeight ? maxHeight : el.scrollHeight;
	    maxWidth = maxWidth > el.scrollWidth ? maxWidth : el.scrollWidth;
	  });
	  viewHeight = maxHeight * 1.1;
	  dim = maxWidth;
	  view = container;
	  scroll(offset);
	  setupEvents(container);
	}

	function setupEvents() {
	  document.addEventListener('keydown', handleKey);
	  window.addEventListener('resize', scroll);
	  if (view) {
	    if (typeof window.ontouchstart !== 'undefined') {
	      view.addEventListener('touchstart', tap);
	      view.addEventListener('touchmove', drag);
	      view.addEventListener('touchend', release);
	      view.addEventListener('touchcancel', release);
	    }
	    addWheelListener(view, wheel);
	    view.addEventListener('mousedown', tap);
	    view.addEventListener('mousemove', drag);
	    view.addEventListener('mouseup', release);
	  }
	}

	function unmount() {
	  document.removeEventListener('keydown', handleKey);
	  window.removeEventListener('resize', scroll);
	}

	function wheel(e) {
	  if (e.deltaY > 0) setActive(getActiveIndex() + 1);
	  else if (e.deltaY < 0) setActive(getActiveIndex() - 1);
	  changed(getActiveIndex());
	}

	function xpos(e) {
	  // touch event
	  if (e.targetTouches && (e.targetTouches.length >= 1)) {
	    return e.targetTouches[0].clientX;
	  }

	  // mouse event
	  return e.clientX;
	}

	function wrap(x) {
	  return (x >= count) ? (x % count) : (x < 0) ? wrap(count + (x % count)) : x;
	}

	function scroll(x) {
	  var i, half, delta, dir, tween, el, alignment;

	  offset = (typeof x === 'number') ? x : offset;
	  center = Math.floor((offset + dim / 2) / dim);
	  delta = offset - center * dim;
	  dir = (delta < 0) ? 1 : -1;
	  tween = -dir * delta * 2 / dim;

	  alignment = 'translateX(' + (view.clientWidth - dim) / 2 + 'px) ';
	  alignment += 'translateY(' + (viewHeight - dim) / 2 + 'px)';

	  // center
	  el = images[wrap(center)];
	  if (el) {
	    el.style[xform] = alignment +
	      ' translateX(' + (-delta / 2) + 'px)' +
	      ' translateX(' + (dir * shift * tween) + 'px)' +
	      ' translateZ(' + (dist * tween) + 'px)' +
	      ' rotateY(' + (dir * angle * tween) + 'deg)';
	    el.style.zIndex = 0;
	    el.style.opacity = 1;
	  }

	  half = count >> 1;
	  for (i = 1; i <= half; ++i) {
	    // right side
	    el = images[wrap(center + i)];
	    if (el) {
	      el.style[xform] = alignment +
	        ' translateX(' + (shift + (dim * i - delta) / 2) + 'px)' +
	        ' translateZ(' + dist + 'px)' +
	        ' rotateY(' + angle + 'deg)';
	      el.style.zIndex = -i;
	      el.style.opacity = (i === half && delta < 0) ? 1 - tween : 1;
	    }

	    // left side
	    el = images[wrap(center - i)];
	    if (el) {
	      el.style[xform] = alignment +
	        ' translateX(' + (-shift + (-dim * i - delta) / 2) + 'px)' +
	        ' translateZ(' + dist + 'px)' +
	        ' rotateY(' + -angle + 'deg)';
	      el.style.zIndex = -i;
	      el.style.opacity = (i === half && delta > 0) ? 1 - tween : 1;
	    }
	  }

	  // center
	  el = images[wrap(center)];
	  if (el) {
	    el.style[xform] = alignment +
	      ' translateX(' + (-delta / 2) + 'px)' +
	      ' translateX(' + (dir * shift * tween) + 'px)' +
	      ' translateZ(' + (dist * tween) + 'px)' +
	      ' rotateY(' + (dir * angle * tween) + 'deg)';
	    el.style.zIndex = 0;
	    el.style.opacity = 1;
	  }
	}

	function track() {
	  var now, elapsed, delta, v;

	  now = Date.now();
	  elapsed = now - timestamp;
	  timestamp = now;
	  delta = offset - frame;
	  frame = offset;

	  v = 1000 * delta / (1 + elapsed);
	  velocity = 0.8 * v + 0.2 * velocity;
	}

	function autoScroll() {
	  var elapsed, delta;

	  if (amplitude) {
	    elapsed = Date.now() - timestamp;
	    delta = amplitude * Math.exp(-elapsed / timeConstant);
	    if (delta > 4 || delta < -4) {
	      scroll(target - delta);
	      requestAnimationFrame(autoScroll);
	    } else  {
	      scroll(target);
	      changed(getActiveIndex());
	    }
	  }
	}

	function tap(e) {
	  pressed = true;
	  reference = xpos(e);

	  velocity = amplitude = 0;
	  frame = offset;
	  timestamp = Date.now();
	  starttimestamp = timestamp;
	  clearInterval(ticker);
	  ticker = setInterval(track, 50);

	  // allow touch devices to handle click event but dont allow dragging on desktops
	  if (e.type == 'mousedown') e.preventDefault();
	  e.stopPropagation();
	  // allow touch devices to handle click event but dont allow dragging on desktops
	  if (e.type == 'mousedown') return false;
	}

	function drag(e) {
	  var x, delta;
	  if (pressed) {
	    x = xpos(e);
	    delta = reference - x;
	    if (delta > 2 || delta < -2) {
	      reference = x;
	      scroll(offset + delta);
	    }
	  }
	  e.preventDefault();
	  e.stopPropagation();
	  return false;
	}

	function release(e) {
	  pressed = false;

	  clearInterval(ticker);
	  target = offset;
	  timestamp = Date.now();
	  if (velocity > 10 || velocity < -10) {
	    amplitude = 0.9 * velocity;
	    target = offset + amplitude;
	    target = Math.round(target / dim) * dim;
	    amplitude = target - offset;
	    requestAnimationFrame(autoScroll);

	    e.preventDefault();
	    e.stopPropagation();
	    return false;
	  } else if (timestamp - starttimestamp > tapMaxConstant) { // Snap to nearest element
	    target = Math.round(target / dim) * dim;
	    amplitude = target - offset;
	    requestAnimationFrame(autoScroll);

	    e.preventDefault();
	    e.stopPropagation();
	    return false;
	  } else {
	    var newtarget = Math.round(target / dim) * dim;
	    amplitude = newtarget - target;
	    target = newtarget;
	    requestAnimationFrame(autoScroll);
	  }
	}

	function handleKey(e) {
	  if (!pressed && (target === offset)) {
	    // Space or PageDown or RightArrow or DownArrow
	    if ([32, 34, 39, 40].indexOf(e.which) >= 0) {
	      target = offset + dim;
	    }
	    // PageUp or LeftArrow or UpArrow
	    if ([33, 37, 38].indexOf(e.which) >= 0) {
	      target = offset - dim;
	    }
	    if (offset !== target) {
	      amplitude = target - offset;
	      timestamp = Date.now();
	      requestAnimationFrame(autoScroll);
	      return true;
	    }
	  }
	}

	function flowTo(to) {
	  var centerIndex = getActiveIndex();
	  if (to == centerIndex) {
	    onActiveClick(centerIndex);
	  } else {
	    var offsetPosition;
	    if (to - centerIndex > (count - 1)/2) offsetPosition = (to - centerIndex) - count;
	    else if (to - centerIndex <= -(count - 1)/2) offsetPosition = (to - centerIndex) + count;
	    else offsetPosition = to - centerIndex;
	    target = offset + offsetPosition * dim;
	    amplitude = target - offset;
	    timestamp = Date.now();
	    requestAnimationFrame(autoScroll);
	    return true;
	  }
	}

	function setActive(to) {
	  target = dim * to;
	  scroll(dim * to);
	}

	function getActiveIndex() {
	  var centerIndex = center % count;
	  while (centerIndex < 0) centerIndex += count;
	  return centerIndex;
	}

	function getActiveElement() {
	  return images[getActiveIndex()];
	}

	function getActiveId() {
	  return images[getActiveIndex()].id;
	}

	function changed(to) {
	  if (oldActiveIndex != to) {
	    onChange(to, oldActiveIndex);
	    oldActiveIndex = to;
	  }
	}

	xform = 'transform';
	['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
	  var e = prefix + 'Transform';
	  if (typeof document.body.style[e] !== 'undefined') {
	    xform = e;
	    return false;
	  }
	  return true;
	});

	module.exports = {
	  initialize: initialize,
	  flowTo: flowTo,
	  setActive: setActive,
	  getActiveId: getActiveId,
	  getActiveElement: getActiveElement,
	  getActiveIndex: getActiveIndex,
	  unmount: unmount,
	};


/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
	 * raf.js
	 * https://github.com/ngryman/raf.js
	 *
	 * original requestAnimationFrame polyfill by Erik Möller
	 * inspired from paul_irish gist and post
	 *
	 * Copyright (c) 2013 ngryman
	 * Licensed under the MIT license.
	 */

	(function(window) {
		var lastTime = 0,
			vendors = ['webkit', 'moz'],
			requestAnimationFrame = window.requestAnimationFrame,
			cancelAnimationFrame = window.cancelAnimationFrame,
			i = vendors.length;

		// try to un-prefix existing raf
		while (--i >= 0 && !requestAnimationFrame) {
			requestAnimationFrame = window[vendors[i] + 'RequestAnimationFrame'];
			cancelAnimationFrame = window[vendors[i] + 'CancelRequestAnimationFrame'];
		}

		// polyfill with setTimeout fallback
		// heavily inspired from @darius gist mod: https://gist.github.com/paulirish/1579671#comment-837945
		if (!requestAnimationFrame || !cancelAnimationFrame) {
			requestAnimationFrame = function(callback) {
				var now = +Date.now(),
					nextTime = Math.max(lastTime + 16, now);
				return setTimeout(function() {
					callback(lastTime = nextTime);
				}, nextTime - now);
			};

			cancelAnimationFrame = clearTimeout;
		}

		// export to window
		window.requestAnimationFrame = requestAnimationFrame;
		window.cancelAnimationFrame = cancelAnimationFrame;
	}(window));


/***/ },
/* 6 */
/***/ function(module, exports) {

	// https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Listening_to_this_event_across_browser
	// creates a global "addWheelListener" method
	// example: addWheelListener( elem, function( e ) { console.log( e.deltaY ); e.preventDefault(); } );
	(function(window,document) {

	    var prefix = "", _addEventListener, support;

	    // detect event model
	    if ( window.addEventListener ) {
	        _addEventListener = "addEventListener";
	    } else {
	        _addEventListener = "attachEvent";
	        prefix = "on";
	    }

	    // detect available wheel event
	    support = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
	              document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
	              "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox

	    window.addWheelListener = function( elem, callback, useCapture ) {
	        _addWheelListener( elem, support, callback, useCapture );

	        // handle MozMousePixelScroll in older Firefox
	        if( support == "DOMMouseScroll" ) {
	            _addWheelListener( elem, "MozMousePixelScroll", callback, useCapture );
	        }
	    };

	    function _addWheelListener( elem, eventName, callback, useCapture ) {
	        elem[ _addEventListener ]( prefix + eventName, support == "wheel" ? callback : function( originalEvent ) {
	            !originalEvent && ( originalEvent = window.event );

	            // create a normalized event object
	            var event = {
	                // keep a ref to the original event object
	                originalEvent: originalEvent,
	                target: originalEvent.target || originalEvent.srcElement,
	                type: "wheel",
	                deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
	                deltaX: 0,
	                deltaZ: 0,
	                preventDefault: function() {
	                    originalEvent.preventDefault ?
	                        originalEvent.preventDefault() :
	                        originalEvent.returnValue = false;
	                }
	            };

	            // calculate deltaY (and deltaX) according to the event
	            if ( support == "mousewheel" ) {
	                event.deltaY = - 1/40 * originalEvent.wheelDelta;
	                // Webkit also support wheelDeltaX
	                originalEvent.wheelDeltaX && ( event.deltaX = - 1/40 * originalEvent.wheelDeltaX );
	            } else {
	                event.deltaY = originalEvent.detail;
	            }

	            // it's time to fire the callback
	            return callback( event );

	        }, useCapture || false );
	    }

	})(window,document);


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function (tagName, maxHeight, maxWidth) {
	  var style = document.createElement("style");
	  var str = "\
	    .coverflow {\
	        overflow: hidden;\
	        perspective: 1000px;\
	        -webkit-perspective: 1000px;\
	        transform-style: preserve-3d;\
	        -webkit-transform-style: preserve-3d;\
	    }\
	    \
	    .coverflow > " + tagName + " {" +
	    ((maxHeight) ? "   height : " + maxHeight + "px;" : "") +
	    ((maxWidth) ? "   width : " + maxWidth + "px;" : "") +
	    "   position: absolute;\
	        top: 0;\
	        left: 0;\
	        opacity: 0;\
	        border: none;\
	    }\
	  ";
	  style.appendChild(document.createTextNode(str));
	  document.head.appendChild(style);
	}


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";

	function isEquivalent(a, b) {
	    // Create arrays of property names
	    var aProps = Object.getOwnPropertyNames(a);
	    var bProps = Object.getOwnPropertyNames(b);

	    // If number of properties is different,
	    // objects are not equivalent
	    if (aProps.length != bProps.length) {
	        return false;
	    }

	    for (var i = 0; i < aProps.length; i++) {
	        var propName = aProps[i];

	        // If values of same property are not equal,
	        // objects are not equivalent
	        if (a[propName] !== b[propName]) {
	            return false;
	        }
	    }

	    // If we made it this far, objects
	    // are considered equivalent
	    return true;
	}

	module.exports = isEquivalent;

/***/ }
/******/ ]);